import { render, staticRenderFns } from "./modalMetodologiaSobreaviso.vue?vue&type=template&id=f409cdbc&scoped=true&"
import script from "./modalMetodologiaSobreaviso.vue?vue&type=script&lang=js&"
export * from "./modalMetodologiaSobreaviso.vue?vue&type=script&lang=js&"
import style0 from "./modalMetodologiaSobreaviso.vue?vue&type=style&index=0&id=f409cdbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f409cdbc",
  null
  
)

export default component.exports